import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Container } from 'react-bootstrap';

const containerStyle = {
  width: "75%",
  height: "500px",
  borderRadius: "20px"

};



const locations = {
  house: { lat: 40.0289737, lng: 0.0347786 }, // Calle Antonio Machado, 20, Benicassim
  beach: { lat: 40.026832, lng:  0.043992 }, // Approximate location near the beach
  fibFestival: { lat: 40.0500, lng: 0.0595 }, // Approximate FIB Festival location
};


const paths = [
  [locations.house, locations.beach], // House → Beach
  [locations.house, locations.fibFestival], // House → FIB Festival
];

const GoogleMapComponent = () => {
  return (
    <Container className="d-flex justify-content-center">
      <LoadScript googleMapsApiKey="AIzaSyDbvC73OS0eYstod843aMyiUeNitMJToAM">
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={locations.house}
          zoom={13}>
          <Marker position={locations.house} label="🏠 Villa Aleksandra" />
          <Marker position={locations.beach} label="🏖️ Playa" />
          <Marker position={locations.fibFestival} label="🎶 FIB Festival" />

        </GoogleMap>
      </LoadScript>
    </Container>
  );
};

export default GoogleMapComponent;
